const WEBHOOK_URL =
  'https://script.google.com/macros/s/AKfycbytuuXzZzJ8rGUg1p_9UZs3JhRdRj0Xq65XNix92vL_Rush96xjPLW0hdgbCT7rXRCN/exec'

function getRefParam(): string {
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get('ref') || ''
  } catch {
    return ''
  }
}

interface AccessGrantedPayload {
  event: 'access_granted'
  name: string
  email: string
  page: string
  ref: string
  userAgent: string
}

interface AccessRequestedPayload {
  event: 'access_requested'
  name: string
  email: string
  note: string
  page: string
  ref: string
  userAgent: string
}

type WebhookPayload = AccessGrantedPayload | AccessRequestedPayload

function sendToWebhook(payload: WebhookPayload): void {
  try {
    fetch(WEBHOOK_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload),
    }).catch(() => {
      // Silent fail — don't disrupt the user experience
    })
  } catch {
    // Silent fail
  }
}

export function logAccessGranted(name: string, email: string): void {
  sendToWebhook({
    event: 'access_granted',
    name,
    email,
    page: window.location.href,
    ref: getRefParam(),
    userAgent: navigator.userAgent,
  })
}

export function logAccessRequested(
  name: string,
  email: string,
  note: string,
): void {
  sendToWebhook({
    event: 'access_requested',
    name,
    email,
    note,
    page: window.location.href,
    ref: getRefParam(),
    userAgent: navigator.userAgent,
  })
}
